/**
 * DevExtreme (esm/__internal/viz/core/themes/generic/light/contants.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const WHITE = "#ffffff";
export const BLACK = "#000000";
export const LIGHT_GREY = "#d3d3d3";
export const GREY_GREEN = "#303030";
export const SOME_GREY = "#2b2b2b";
export const RED = "#ff0000";
export const PRIMARY_TITLE_COLOR = "#232323";
export const SECONDARY_TITLE_COLOR = "#767676";
export const NONE = "none";
export const SOLID = "solid";
export const TOP = "top";
export const RIGHT = "right";
export const BOTTOM = "bottom";
export const LEFT = "left";
export const CENTER = "center";
export const INSIDE = "inside";
export const OUTSIDE = "outside";
